const zh: Record<string, string> = {
  // === LandingPage ===
  'diceIcon': '骰子金币',
  'gameTitle': '天国骰子',
  'playerBalance': '玩家余额: {amount} 格罗申',
  'startGame': '开始游戏',
  'challengers': '挑战者',
  'diceCollection': '骰子收藏',
  'diceShop': '骰子商店',
  'gameSettings': '游戏设置',
  'back': '返回',
  'footerContact': 'WeChat添加cavi06，一起进群吹水',

  // === ChallengerSelector ===
  'selectChallenger': '选择挑战者',
  'challengerSubtitle': '战胜挑战者除了能赢得下注金额外，还有机会获得他的特殊骰子作为奖励！',
  'yourGroschen': '你当前的格罗申: ',
  'targetScore': '目标分数:',
  'betAmount': '下注金额:',
  'insufficientFunds': '格罗申不足!',
  'startChallenge': '开始挑战',

  // === GameControls ===
  'opponentActing': '对手正在行动...',
  'rollDice': '掷骰子',
  'scoreAndReroll': '计分并重掷',
  'scoreAndEndTurn': '计分并结束回合',
  'endTurn': '结束回合',
  'playAgain': '再来一局',

  // === ScoreBoard ===
  'score': '分数',
  'computer': '电脑',
  'currentTurn': '当前回合',

  // === GameSettings ===
  'computerDifficulty': '电脑难度',
  'easy': '简单 (目标分数: 2000)',
  'medium': '中等 (目标分数: 4000)',
  'hard': '困难 (目标分数: 10000)',
  'language': '语言',
  'langZh': '中文',
  'langEn': 'English',
  'save': '保存',
  'cancel': '取消',

  // === GameRules ===
  'gameRules': '游戏规则',
  'farkleRules': 'Farkle 游戏规则',
  'welcomeTitle': '欢迎来到天国骰子',
  'welcomeText': '这是一款完全由AI编写的Farkle游戏，游戏应该还有不少bug，而且暂时还没有顾及到视觉体验，望海涵。',
  'contactText': '如果您发现有bug或有任何好的建议，请WeChat联系我：mzz0606。',
  'gameObjectiveTitle': '游戏目标',
  'gameObjectiveText': '成为第一个达到目标分数（默认4,000分）的玩家。',
  'bettingRulesTitle': '下注规则',
  'bettingRulesText1': '每局游戏开始时，玩家可以下注格罗申。下注金额会立即从玩家余额中扣除。',
  'bettingRulesText2': '如果玩家赢得游戏，将获得下注金额的两倍（即净赢得下注金额）；如果电脑赢得游戏，玩家将失去已下注的格罗申。',
  'bettingRulesText3': '玩家初始拥有50格罗申。如果格罗申用完，玩家可以通过下注0格罗申赚取特殊骰子进行出售，很快你就会东山再起。',
  'gameFlowTitle': '游戏流程',
  'gameFlowText': '玩家轮流掷骰子并收集分数。每个回合，玩家掷六个骰子并必须至少选择一个有效的得分组合。',
  'scoringCombosTitle': '得分组合',
  'scoringSingle1': '单个1 = 100分',
  'scoringSingle5': '单个5 = 50分',
  'scoringTriple1': '三个1 = 1000分',
  'scoringTriple2': '三个2 = 200分',
  'scoringTriple3': '三个3 = 300分',
  'scoringTriple4': '三个4 = 400分',
  'scoringTriple5': '三个5 = 500分',
  'scoringTriple6': '三个6 = 600分',
  'scoringFourOfKind': '四个相同 = 三个相同分数的两倍',
  'scoringFiveOfKind': '五个相同 = 三个相同分数的四倍',
  'scoringSixOfKind': '六个相同 = 三个相同分数的八倍',
  'scoringSmallStraight': '1-2-3-4-5（小顺子）= 500分',
  'scoringLargeStraight': '2-3-4-5-6（大顺子）= 750分',
  'scoringFullStraight': '1-2-3-4-5-6（全顺）= 1500分',
  'farkleTitle': 'Farkle（无分）',
  'farkleText': '如果玩家掷骰子后没有任何得分组合，这称为"Farkle"。玩家失去当前回合累积的所有分数，回合结束。',
  'turnEndTitle': '回合结束',
  'turnEndText': '玩家可以选择"锁定并结束回合"来保存当前回合的分数，或继续掷剩余的骰子来获取更多分数（但风险更大）。',
  'gameEndTitle': '游戏结束',
  'gameEndText': '当一名玩家达到目标分数后，游戏结束。',
  'close': '关闭',

  // === DiceShop ===
  'buyDice': '购买骰子',
  'sellDice': '出售骰子',
  'availableGroschen': '可用格罗申:',
  'insufficientGroschenBuy': '格罗申不足，无法购买',
  'maxOwnedReached': '已达到 {name} 的最大拥有数量 ({max})',
  'cannotSellInUse': '无法出售正在使用中的骰子',
  'purchaseSuccess': '成功购买 {name}',
  'sellSuccess': '成功出售 {name}，获得 {amount} 格罗申',
  'owned': '已拥有: {count}/{max} 个',
  'maxReached': '（已达上限）',
  'groschen': '格罗申',
  'maxReachedBtn': '已达上限',
  'buy': '购买',
  'sellNote': '出售骰子可获得原价的70%格罗申。正在使用中的骰子无法出售。',
  'ownedCount': '拥有: {count} 个 (已用 {used} 个)',
  'noSellableDice': '您没有可出售的骰子',
  'inUse': '使用中',
  'sell': '出售',
  'confirmPurchase': '确认购买',
  'confirmSell': '确认出售',
  'confirmBuyText': '确定要购买 {name} 吗？价格: {price} 格罗申',
  'confirmSellText': '确定要出售 {name} 吗？您将获得 {amount} 格罗申。',

  // === DiceSelector ===
  'selectDice': '选择骰子',
  'onlyOwned': '你只拥有 {count} 个 {name}，已全部使用',
  'configSaved': '成功保存骰子配置！',
  'selectDiceCombo': '选择骰子组合',
  'used': '已用 {used}/{total}',

  // === GameModal ===
  'confirm': '确认',
  'ok': '确定',

  // === RewardDiceModal ===
  'congratsSpecialDice': '恭喜获得特殊骰子',
  'congratsText': '恭喜你获得了一个特殊骰子！',
  'rewardMessage': '这个特殊骰子已添加到你的收藏中，可以在骰子选择器中使用。',
  'awesome': '太棒了！',

  // === Game.tsx ===
  'player': '玩家',
  'forfeit': '放弃',
  'playerTotalScore': '玩家总分',
  'opponentTotalScore': '{name}总分',
  'turnScore': '回合得分',
  'selectionScore': '选择得分',
  'selectToKeep': '选择要保留的骰子。',
  'invalidSelection': '当前选择组合无分值。',
  'pleaseSelect': '请选择要保留的骰子。',
  'invalidSelectRetry': '无效的选择，请重新选择有效的骰子组合',
  'computerRolling': '电脑正在掷骰子...',
  'computerThinking': '电脑正在思考...选择了第 {count} 个骰子',
  'endTurnMsg': '{name}结束回合，获得 {turnScore} 分，总分 {totalScore}...',
  'selectionScoreMsg': '选择得分：{selection}，回合得分：{turn}',
  'forfeitTitle': '确认放弃',
  'forfeitContent': '您确定要放弃本局游戏吗？\n您将损失已投注的 {bet} 格罗申。',
  'gameOver': '游戏结束',
  'playerWins': '{name}获得胜利！',
  'wonGroschen': '\n你赢得了{amount}格罗申！',
  'currentGroschen': '\n你当前拥有{amount}格罗申。',
  'lostGroschen': '\n你失去了{amount}格罗申。',
  'defeatedChallenger': '\n你战胜了{name}，赢得了{amount}格罗申！',
  'gotSpecialDice': '\n并获得了他的特殊骰子：{name}！',
  'congratsDefeat': '\n恭喜！你战胜了{name}！',
  'challengerWins': '{name}获胜，再接再厉！\n',
  'challengerLostGroschen': '你失去了{amount}格罗申。',
  'insufficientGroschenChallenge': '你没有足够的格罗申来挑战{name}！需要{amount}格罗申。',

  // === BettingPanel ===
  'placeBet': '下注',
  'currentGroschenLabel': '当前格罗申: {amount}',
  'easyMode': '简单模式',
  'mediumMode': '中等模式',
  'hardMode': '困难模式',
  'betLimit': '下注上限: {max} 格罗申',
  'betAmountLabel': '下注金额 (0-{max})',
  'confirmBet': '确认下注',

  // === DiceCollection ===
  'toCollect': '待收集',
  'probabilityOf': '{name}的点数概率：',
  'point': '{num}点: {prob}%',
  'maxOwnedLabel': '拥有上限: {max}',
  'collectionComplete': '已收集完成！点击骰子查看骰子详情',
  'continueCollecting': '继续收集骰子以完成收藏',
  'collected': '{count}/{total} 已收集',
  'noSetsUnlocked': '尚未解锁任何骰子套。继续收集骰子以解锁隐藏套装！',

  // === useDiceShop hook ===
  'insufficientGroschenTitle': '格罗申不足',
  'insufficientGroschenContent': '您没有足够的格罗申购买这个骰子。需要 {price} 格罗申。',
  'maxQuantityTitle': '已达到最大数量',
  'maxQuantityContent': '您已经拥有最大数量({max})的这种骰子。',

  // === Dice Names ===
  'dice.NORMAL.name': '普通骰子',
  'dice.NORMAL.desc': '标准的六面骰子，每个点数概率相等',
  'dice.CAVIER_1.name': '卡维尔的测试骰子1',
  'dice.CAVIER_1.desc': '这个骰子……好像有点bug',
  'dice.CAVIER_2.name': '卡维尔的测试骰子2',
  'dice.CAVIER_2.desc': '这个骰子……好像有点bug',
  'dice.CAVIER_3.name': '卡维尔的测试骰子3',
  'dice.CAVIER_3.desc': '这个骰子……好像有点bug',
  'dice.CAVIER_4.name': '卡维尔的测试骰子4',
  'dice.CAVIER_4.desc': '这个骰子……好像有点bug',
  'dice.CAVIER_5.name': '卡维尔的测试骰子5',
  'dice.CAVIER_5.desc': '这个骰子……好像有点bug',
  'dice.CAVIER_6.name': '卡维尔的测试骰子6',
  'dice.CAVIER_6.desc': '这个骰子……好像有点bug',
  'dice.ADULT.name': '大人的骰子',
  'dice.ADULT.desc': '某个大人掉落的骰子，也许有什么特殊效果',
  'dice.EVEN.name': '偶数骰子',
  'dice.EVEN.desc': '更容易出偶数的骰子',
  'dice.ODD.name': '奇数骰子',
  'dice.ODD.desc': '更容易出奇数的骰子',
  'dice.HEAVEN.name': '天国骰子',
  'dice.HEAVEN.desc': '传说中的天国骰子，请你不要卖掉它',
  'dice.KNIGHT.name': '骑士的骰子',
  'dice.KNIGHT.desc': '象征着骑士的荣誉和忠贞',
  'dice.LUCKY.name': '幸运之骰',
  'dice.LUCKY.desc': '容易出1和5，但数量有限',
  'dice.SMALL_LUCKY.name': '小幸运骰子',
  'dice.SMALL_LUCKY.desc': '容易出1和5，但数量有限',
  'dice.MINI.name': 'mini骰子',
  'dice.MINI.desc': '名称与外观不符，容易出1和6',
  'dice.CLOTHED.name': '穿衣骰子',
  'dice.CLOTHED.desc': '容易出156，让人穿衣服',
  'dice.RIGGED.name': '动过手脚的骰子',
  'dice.RIGGED.desc': '最基础的出千骰子，容易出2',
  'dice.UNPOPULAR.name': '不受欢迎的骰子',
  'dice.UNPOPULAR.desc': '被人嫌弃，也许好用？',
  'dice.UNLUCKY.name': '厄运骰子',
  'dice.UNLUCKY.desc': '大概率出中间的数字，最好不要用这玩意',
  'dice.TRIPLE_THREE.name': '三圣一骰子',
  'dice.TRIPLE_THREE.desc': '3！3！3！',
  'dice.KAVI_C.name': '卡维的C测骰子',
  'dice.KAVI_C.desc': '不知道有什么用',
  'dice.ANTIOCH.name': '圣安的骰子',
  'dice.ANTIOCH.desc': '好像6个面都是3，但也只有3个',
  'dice.LOADED.name': '灌铅骰子',
  'dice.LOADED.desc': '5的那一面被加了重量',
  'dice.ANGEL_AN.name': '安骰子',
  'dice.ANGEL_AN.desc': '天使三骰之"安"，容易出6',
  'dice.ANGEL_JI.name': '吉骰子',
  'dice.ANGEL_JI.desc': '天使三骰之"吉"，容易出6',
  'dice.ANGEL_LA.name': '拉骰子',
  'dice.ANGEL_LA.desc': '天使三骰之"拉"，容易出6',
  'dice.DEMON_LU.name': '卢骰子',
  'dice.DEMON_LU.desc': '恶魔三骰之"卢"，容易出6',
  'dice.DEMON_XI.name': '西骰子',
  'dice.DEMON_XI.desc': '恶魔三骰之"西"，容易出6',
  'dice.DEMON_FA.name': '法骰子',
  'dice.DEMON_FA.desc': '恶魔三骰之"法"，容易出6',

  // === Challenger Names ===
  'challenger.tou-ge.name': '头哥',
  'challenger.tou-ge.desc': '似乎是场子里最不聪明的那个',
  'challenger.real-gambler.name': '真正的赌狗',
  'challenger.real-gambler.desc': '赌到天昏地暗',
  'challenger.dance-boss.name': '舞场老板',
  'challenger.dance-boss.desc': '懂的都懂',
  'challenger.cheater.name': '手脚不太干净的人',
  'challenger.cheater.desc': '臭名远扬的出千高手',
  'challenger.a-san.name': '阿三',
  'challenger.a-san.desc': '他就是阿三',
  'challenger.malcolm.name': '马尔科姆',
  'challenger.malcolm.desc': '只能说有点实力，但不多',
  'challenger.merchant.name': '远方来的商人',
  'challenger.merchant.desc': '跋山涉水过来的商人，肯定有一些运气在上面',
  'challenger.small-cavier.name': '小卡维',
  'challenger.small-cavier.desc': '不知道实力如何',
  'challenger.enhance-a-san.name': '加强版的阿三',
  'challenger.enhance-a-san.desc': '他还是那么喜欢三',
  'challenger.heaven-knight.name': '天国骑士团',
  'challenger.heaven-knight.desc': '手上拿着来自天国的骰子',
  'challenger.alonso.name': '阿隆索大人',
  'challenger.alonso.desc': '传说中的阿隆索大人',
  'challenger.cavier.name': '卡维尔',
  'challenger.cavier.desc': '你不可能战胜他。',
  'challenger.unknown': '未知挑战者',

  // === Dice Sets ===
  'diceSet.cavier-set.name': '卡维尔的测试骰子',
  'diceSet.cavier-set.desc': '如果你能收集完成……那么你已经无敌了',
  'diceSet.odd-set.name': '奇数套',
  'diceSet.odd-set.desc': '收集所有奇数骰子',
  'diceSet.even-set.name': '偶数套',
  'diceSet.even-set.desc': '收集所有偶数骰子',
  'diceSet.mini-set.name': '迷你组合',
  'diceSet.mini-set.desc': '收集所有迷你骰子',
  'diceSet.clothed-set.name': '穿衣套',
  'diceSet.clothed-set.desc': '舞场老板喜欢使用的骰子组合',
  'diceSet.rigged-set.name': '老千',
  'diceSet.rigged-set.desc': '这些骰子似乎都被动过手脚...',
  'diceSet.lucky-set.name': '幸运套',
  'diceSet.lucky-set.desc': '收集所有带有幸运属性的骰子',
  'diceSet.gambler-set.name': '天使与恶魔',
  'diceSet.gambler-set.desc': '所谓赌狗，一念成魔，一念成佛',
  'diceSet.triple-three-set.name': '3！3！3！',
  'diceSet.triple-three-set.desc': '3是最完美的数字',
  'diceSet.loaded-set.name': '灌铅骰子',
  'diceSet.loaded-set.desc': '高级的出千手段',
  'diceSet.heaven-knight-set.name': '天国的骑士',
  'diceSet.heaven-knight-set.desc': '代表着天国的荣誉',
  'diceSet.adult-set.name': '大人',
  'diceSet.adult-set.desc': '阿隆索大人专用的骰子组合',
  'diceSet.low-set.name': '鸡肋',
  'diceSet.low-set.desc': '食之无味，弃之可惜',

  // === Privacy Policy ===
  'privacyPolicy': '隐私政策',
  'privacyPolicyContent': '本游戏（天国骰子）尊重并保护用户的隐私。\n\n1. 数据收集\n本游戏使用 Google Analytics 收集匿名的访问数据（如访问量、页面浏览量、设备类型、地理位置等），用于改善游戏体验。我们不会收集您的姓名、邮箱、电话等个人身份信息。\n\n2. 本地存储\n游戏进度、骰子收藏、格罗申余额等数据仅保存在您的浏览器本地存储（localStorage）中，不会上传到任何服务器。\n\n3. Cookie\nGoogle Analytics 可能会使用 Cookie 来区分用户。您可以通过浏览器设置禁用 Cookie。\n\n4. 第三方服务\n本游戏使用以下第三方服务：\n- Google Analytics（数据分析）\n- Vercel（网站托管）\n\n5. 儿童隐私\n本游戏不针对 13 岁以下儿童，不会故意收集儿童的个人信息。\n\n6. 政策更新\n本隐私政策可能会不时更新，更新后的政策将在本页面发布。\n\n如有疑问，请通过游戏内渠道联系我们。',
};

export default zh;
